import React from 'react';

import { Grid, OpenInNew, Link, Typography } from '@cherre-frontend/ui';

export const ValidationParametersPanel: React.FC = ({ children }) => {
  return (
    <div>
      <Grid
        container
        marginTop={2}
        direction='row'
        alignItems='center'
        justifyContent='space-between'
        gap={1}
      >
        <Typography variant='body1'>
          Set account parameters for the validation rules to apply to when
          enabled for specific datasets for your organization:
        </Typography>
        <Link
          href='/dsp/master-files'
          display='flex'
          underline='none'
          fontWeight={600}
        >
          <OpenInNew style={{ height: '15px', alignSelf: 'center' }} />
          View Master Chart of Accounts
        </Link>
      </Grid>
      {children}
    </div>
  );
};
